import React, { useEffect, useState } from "react";
import { IS_PRERENDER } from "@/lib/faro";

const STATS = [
  { value: "46", label: "Años de experiencia" },
  { value: "5", label: "Centros en Vigo · Nigrán · A Cañiza" },
  { value: "25", label: "Vehículos en flota" },
  { value: "100%", label: "Permisos disponibles" },
];

const MARQUEE = [
  "Permiso B",
  "Moto A1 · A2 · A",
  "Cuadriciclo AML",
  "B96 con cámaras 360º",
  "Camión C · C+E",
  "Autobús D",
  "CAP Inicial · Continuo · Puente",
  "Permiso por Puntos",
  "Conducción Segura",
  "Diversidad funcional",
];

const MarqueeGroup = ({ ariaHidden }) => (
  <span className="inline-flex" aria-hidden={ariaHidden || undefined}>
    {MARQUEE.map((item) => (
      <span key={item} className="px-6 text-sm font-bold uppercase tracking-[0.18em] text-white/85">
        <span className="text-[var(--faro-yellow)] mr-6">●</span>
        {item}
      </span>
    ))}
  </span>
);

export default function Stats() {
  // Clone for the seamless loop is client-only so crawlers read the list once
  const [cloned, setCloned] = useState(false);
  useEffect(() => {
    if (!IS_PRERENDER) setCloned(true);
  }, []);

  return (
    <section className="bg-[var(--faro-blue)] text-white" data-testid="stats-section">
      <div className="overflow-hidden border-b border-white/10 py-4" aria-hidden="true">
        <div className="faro-marquee whitespace-nowrap">
          <MarqueeGroup />
          {cloned && <MarqueeGroup ariaHidden />}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {STATS.map((s) => (
          <div key={s.label} className="flex flex-col" data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-[var(--faro-yellow)]">
              {s.value}
            </div>
            <div className="mt-2 text-xs sm:text-sm uppercase tracking-[0.2em] text-white/75 font-semibold">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
